import { actionClient } from '@/api'

const state = {
  topCates: [], // all top cates
  currentTopCateId: '' // current top cate id
}

// actions
const actions = {
  async getTopCate({ commit }, activityId) {
    const topCates = await actionClient.get('member/activity/activity-top-category', {
      query: {activityId}
    })
    commit('setTopCates', topCates)
  },
  setTopCateId({ commit }, cateId) {
    commit('setTopCateId', String(cateId))
  }
}

const getters = {
  currentTopCate: state => {
    if (state.currentTopCateId && state.topCates.length > 0) {
      return state.topCates.find(cate => cate.id == state.currentTopCateId)
    } else {
      return null
    }
  }
}


// mutations
const mutations = {
  setTopCates (state, topCates) {
    state.topCates = topCates
  },
  setTopCateId (state, cateId) {
    state.currentTopCateId = cateId
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
